export const getLink = (notification, role, store_type) => {
    let pageLink = "";
    if (role === "admin" || role ==="Operations Manager" || role === "Client Admin"|| role === "Central Kitchen Manager") {
      switch (notification) {
        case "New product order":
          pageLink = "/finished_products/new_orders";
          break;
        case "New urgent product order":
          pageLink = "/finished_products/urgent_orders";
          break;
        case "Item direct transfer successful":
          pageLink = "/items/alltransfers";
          break;
        case "Product order received":
          pageLink = "/finished_products/orders_in_process";
          break;
        case "Product transfer order":
          pageLink = "/finished_products/transfer_inventory";
          break;
        case "New item order":
          pageLink = "/items/orders_in_process";
          break;
        case "Item order received":
          pageLink = "/items/orders_in_process";
          break;
        case "Item transfer order":
          pageLink = "/items/transfer_inventory";
          break;
        default : 
            pageLink = "";
            break;
      }
    }
    if (role === "Owner") {
      switch (notification) {
        case "New Purchase Order Limit Approval":
          pageLink = "/all_po_owner";
          break;
         default : 
            pageLink = "";
            break;
      }
    }
    if (role === "Central Store Manager") {
      switch (notification) {
        case "New item order":
          pageLink = "/items/orders_in_process";
          break;
        case "New urgent item order":
          pageLink = "/items/urgent_orders";
          break;
        case "New item transfer order":
          pageLink = "/items/centre/all_item_requests";
          break;
          case "Item direct transfer successful":
            pageLink = "/items/alltransfers";
            break;
        case "Item transfer order received":
          pageLink = "/items/centre/all_item_requests";
          break;
        case "Sub-store deficit order":
          pageLink = "/items/orders_in_process";
          break;
        case "Item order received":
          pageLink = "/items/orders_in_process";
          break;
        default : 
          pageLink = "";
          break;
      }
    }
    if (role === "Branch Supervisor") {
      switch (notification) {
        case "Product order approved":
          pageLink = "/finished_products/all_orders";
          break;
        case "Item balance direct transfer successful":
          pageLink = "/items/alltransfers";
          break;
        case "Item order updated":
          pageLink = "/items/all_orders";
          break;
        case "Product order updated":
          pageLink = "/finished_products/all_orders";
          break;
          case "Item direct transfer successful":
            pageLink = "/items/alltransfers";
            break;
        case "Item order approved":
          pageLink = "/items/all_orders";
          break;
        case "Product transfer order":
          pageLink = "/finished_products/transfer_inventory";
          break;

        case "Product order rejected":
          pageLink = "/finished_products/all_orders";
          break;
        case "Item order rejected":
          pageLink = "/items/all_orders";
          break;
        case "Item transfer order":
          pageLink = "/items/transfer_inventory";
          break;

        case "Product order dispatched":
          pageLink = "/finished_products/all_orders";
          break;
        case "Item order dispatched":
          pageLink = "/items/all_orders";
          break;

        case "Product order closed":
          pageLink = "/finished_products/all_orders";
          break;
        case "Item order closed":
          pageLink = "/items/all_orders";
          break;
        case "Equipment order dispatched":
          pageLink = "/equipments/all_orders";
          break;
        default : 
          pageLink = "";
          break;
      }
    }
    if (role === "Main Store Manager" && store_type === "Main Store") {
      switch (notification) {
        case "New item transfer order":
          pageLink = "/items/allItemRequests/to_main";
          break;
          case "Item direct transfer successful":
            pageLink = "/items/alltransfers";
            break;
          case "Item transfer order dispatched":
            pageLink = "/items/all_orders/to/main";
            break;
            case "Item transfer order received":
              pageLink = "/items/allItemRequests/to_main";
              break;
        case "Equipment order dispatched":
          pageLink = "/equipments/all_orders/mainstore";
          break;
        case "Equipment order approved":
          pageLink = "/equipments/all_orders/mainstore";
          break;
        case "Equipment order closed":
          pageLink = "/equipments/all_orders/mainstore";
          break;
        default : 
          pageLink = "";
          break;
      }
    }
    if (role === "Sub Store Manager" && store_type === "Sub Store") {
      switch (notification) {
        case "New item order":
          pageLink = "/items/allItemRequests/to_substore";
          break;
        case "New item order from branch":
          pageLink = "/items/ordered/by/branch";
          break;
          case "New item transfer order":
            pageLink = "/items/allItemRequests/to_substore";
            break;
          case "Item direct transfer successful":
            pageLink = "/items/alltransfers";
            break;
        case "Item transfer order dispatched":
          pageLink = "/items/all_orders";
          break;
        case "Item transfer order closed":
          pageLink = "/items/all_orders";
          break;
        case "Equipment order dispatched":
          pageLink = "/equipments/all_orders/substore";
          break;
        case "Equipment order approved":
          pageLink = "/equipments/all_orders/substore";
          break;
        case "Equipment order closed":
          pageLink = "/equipments/all_orders/substore";
          break;
        default : 
          pageLink = "";
          break;
      }
    }
    if (role === "Equipment Store Manager") {
      switch (notification) {
        case "Purchase order received":
          pageLink = "/all_equipment_po";
          break;
        case "Equipment order received":
          pageLink = "/equipments/orders_in_process";
          break;
        default : 
          pageLink = "";
          break;
      }
    } 
    if (role === "Storekeeper") {
      switch (notification) {
        case "New item order":
          pageLink = "/items/orders_in_process";
          break;
        case "New urgent item order":
          pageLink = "/items/urgent_orders";
          break;
        case "New item transfer order":
          pageLink = "/items/centre/all_item_requests";
          break;
          case "Item direct transfer successful":
            pageLink = "/items/alltransfers";
            break;
        case "Item transfer order received":
          pageLink = "/items/centre/all_item_requests";
          break;
        case "Sub-store deficit order":
          pageLink = "/items/orders_in_process";
          break;
        case "Item order received":
          pageLink = "/items/orders_in_process";
          break;
          case "New product order":
            pageLink = "/finished_products/new_orders";
            break;
          case "New urgent product order":
            pageLink = "/finished_products/urgent_orders";
            break;
          case "Item direct transfer successful":
            pageLink = "/items/alltransfers";
            break;
          case "Product order received":
            pageLink = "/finished_products/orders_in_process";
            break;
          case "Product transfer order":
            pageLink = "/finished_products/transfer_inventory";
            break;
          case "New item order":
            pageLink = "/items/orders_in_process";
            break;
          case "Item order received":
            pageLink = "/items/orders_in_process";
            break;
          case "Item transfer order":
            pageLink = "/items/transfer_inventory";
            break;
          default : 
              pageLink = "";
              break;
      }
    }
    return pageLink;
  };